import { render, staticRenderFns } from "./ViewStoreProfileContainer.vue?vue&type=template&id=04561044&"
import script from "./ViewStoreProfileContainer.vue?vue&type=script&lang=js&"
export * from "./ViewStoreProfileContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports